import React from 'react';
import { CustomHeader } from 'react-calendar-timeline';

const TimelineHourHeader: React.FC = () => {
  return (
    // @ts-ignore
    <CustomHeader unit="hour">
      {(props: any) => {
        const {
          headerContext: { intervals },
          getRootProps,
          getIntervalProps,
        } = props;
        return (
          <div {...getRootProps()} className="hourHeader">
            {intervals.map((interval: any) => {
              const hour = interval.startTime.hour();
              const shouldDisplay = hour % 3 === 0;

              const intervalStyle: React.CSSProperties = {
                lineHeight: '20px',
                fontFamily: '"Roboto Condensed",Helvetica,Arial,"sans-serif"',
                fontSize: '11px',
                fontWeight: 'normal',
              };

              // Format with leading space for single-digit hours to align with 12am/12pm
              const formattedTime = interval.startTime.format('ha');
              const displayTime =
                formattedTime.length === 3
                  ? ` ${formattedTime}`
                  : formattedTime;

              return (
                <div
                  key={interval.startTime.valueOf()}
                  {...getIntervalProps({
                    interval,
                    style: intervalStyle,
                  })}
                >
                  {shouldDisplay && displayTime}
                </div>
              );
            })}
          </div>
        );
      }}
    </CustomHeader>
  );
};

export default TimelineHourHeader;
